import { getMumulLiveProfileStatus } from './getMumulLiveProfileStatus';
import { getMumulLiveCurrentCampaign } from './getMumulLiveCurrentCampaign';

export const mumulLiveService = {
  getMumulLiveProfileStatus,
  getMumulLiveCurrentCampaign,
};
